import { createSelector } from "reselect";
import get from "lodash/get";
import { uploadIdentitySelector } from "./forms/uploadIdentity";
import { compactJoin } from "utils/helpers";

export const uploadIdentityDetailsDomain = state =>
  get(state, "api.uploadIdentityDetails.data", {});

export const uploadIdentityDetailsSelector = createSelector(
  uploadIdentityDetailsDomain,
  uploadIdentityDetails => uploadIdentityDetails
);

export const makeSelectUploadIdentityDetails = () =>
  uploadIdentityDetailsSelector;

export const uploadIdentitySummary = createSelector(
  uploadIdentityDetailsSelector,
  uploadIdentitySelector,
  (uploadIdentityDetails, uploadIdentityForm) => {
    const orderRef = get(uploadIdentityDetails, "order_ref");
    const selectedNumber = get(uploadIdentityDetails, "number");
    const contactEmail = get(uploadIdentityForm, "email");
    const first_name = get(uploadIdentityForm, "first_name", "");
    const middle_name = get(uploadIdentityForm, "middle_name", "");
    const last_name = get(uploadIdentityForm, "last_name", "");
    const name = compactJoin([first_name, middle_name, last_name], " ").trim();
    const contactNumber = `${get(uploadIdentityForm, "country_code")}${get(
      uploadIdentityForm,
      "contact_number"
    )}`;
    const deliveryDateTime = get(uploadIdentityForm, "delivery_slot_full_data");
    const deliveryAddress = get(uploadIdentityForm, "delivery_location");

    return {
      name,
      contactEmail,
      contactNumber,
      selectedNumber,
      orderRef,
      deliveryDateTime,
      deliveryAddress
    };
  }
);

export const makeSelectUploadIdentitySummary = () => uploadIdentitySummary;
